export const GET_UPGRADE_REQUIREMENTS = `
import AFLUpgradeExchange from 0xAFLContracts

access(all) fun main (templateId: UInt64): [AFLUpgradeExchange.Requirement]? {
    return AFLUpgradeExchange.getUpgradeRequirements(templateId: templateId)
}
    `
